export enum ModalTypes {
  None,
  Project,
  Zoom,
  NewGroup,
  CreateOrganization,
}
